import React from 'react';

import { JackpotDetailsDescription } from './jackpot-details-description';
import { JackpotDetailsWinners } from './jackpot-details-winners';
import { JackpotDetailsHeader } from './jackpot-details-header';

interface JackpotDetailsProps {
  onClose: () => void;
}

export const JackpotDetails: React.FC<JackpotDetailsProps> = ({ onClose }) => {
  return (
    <div className="jackpot-widget-popup">
      <div className="jackpot-widget-popup-inner">
        <JackpotDetailsHeader onClose={onClose} />
        <JackpotDetailsWinners />
        <JackpotDetailsDescription />
      </div>
    </div>
  );
};
